import { jsx as _jsx } from "react/jsx-runtime";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import capitalize from "lodash/capitalize";
import lowerCase from "lodash/lowerCase";
import React from "react";
import { styled } from "styled-components";
import { StackedPillsWithTitle } from "@faire/retailer/components/LoggedOutPills/StackedPillsWithTitle";
import { discoverSearch } from "@faire/retailer/lib/seoPaths";
import { useLoggedOutCategoryPageCatNavResponse } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageCatNav/useLoggedOutCategoryPageCatNavResponse";
export var LoggedOutCategoryPageMoreInC3Pills = function() {
    var _useLoggedOutCategoryPageCatNavResponse = useLoggedOutCategoryPageCatNavResponse(), _useLoggedOutCategoryPageCatNavResponse_data = _useLoggedOutCategoryPageCatNavResponse.data, moreInC3CategoryName = _useLoggedOutCategoryPageCatNavResponse_data.moreInC3CategoryName, moreInC3Terms = _useLoggedOutCategoryPageCatNavResponse_data.moreInC3Terms;
    if (!moreInC3CategoryName || !(moreInC3Terms === null || moreInC3Terms === void 0 ? void 0 : moreInC3Terms.length)) {
        return null;
    }
    var pills = moreInC3Terms.map(function(term) {
        return {
            pillContent: capitalize(term),
            linkTo: discoverSearch(lowerCase(term))
        };
    });
    return /*#__PURE__*/ _jsx(StyleStackedPillsWithTitle, {
        pills: pills,
        title: moreInC3CategoryName,
        useCarouselOnMobile: true
    });
};
var StyleStackedPillsWithTitle = styled(StackedPillsWithTitle).withConfig({
    componentId: "sc-698cf21a-0"
})([
    "",
    "{padding:0 ",
    ";}margin-bottom:",
    ";"
], responsiveMediaQueries.mobile, getSpacing("2x"), getSpacing("8x"));
